import React from 'react';
import { Badge } from './Badge';
interface UrgencyBadgeProps {
  urgency: string;
  className?: string;
}
export function UrgencyBadge({
  urgency,
  className = ''
}: UrgencyBadgeProps) {
  let color = 'var(--muted-foreground)';
  let isCritical = false;
  switch (urgency.toUpperCase()) {
    case 'KRITIS':
    case 'MENDESAK':
      color = 'var(--destructive)';
      isCritical = true;
      break;
    case 'TINGGI':
    case 'WASPADA':
      color = 'var(--status-standby)';
      break;
    case 'SEDANG':
    case 'PERHATIAN':
      color = 'var(--status-info)';
      break;
    case 'RENDAH':
    case 'NORMAL':
    case 'INFO':
      color = 'var(--status-active)';
      break;
    default:
      color = 'var(--muted-foreground)';
      break;
  }
  return <Badge variant={isCritical ? 'destructive' : 'outline'} className={`text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 ${isCritical ? 'shadow-[0_0_10px_rgba(var(--destructive),0.2)]' : ''} ${className}`} style={!isCritical ? {
    color: color,
    borderColor: color,
    backgroundColor: `color-mix(in srgb, ${color} 10%, transparent)`
  } : {}} data-id="element-529">
      {urgency}
    </Badge>;
}